import { LazyImage } from '@components/common/image'
import { staticFile } from '@common/utils'

const TestimonialCard = ({ imageUrl, name, content, role }) => (
  <div className="flex flex-col justify-center bg-white shadow-lg p-10 mx-8 rounded-lg max-w-lg relative lg:h-64 mt-32 lg:mt-20 lg:mx-16">
    <img
      src={staticFile('/images/book-trial-class/shape-1.svg')}
      className="absolute top-0 left-0 h-8 ml-5 -mt-5 lg:h-12"
      alt="Background Vector Shape"
    />
    <img
      src={staticFile('/images/book-trial-class/shape-2.svg')}
      className="absolute top-0 right-0 h-12 mr-5 -mt-5 hidden lg:flex"
      alt="Background Vector Shape"
    />
    <img
      src={staticFile('/images/book-trial-class/shape-3.svg')}
      className="absolute bottom-0 left-0 h-20 -ml-5 -mb-5 hidden lg:flex"
      alt="Background Vector Shape"
    />
    <img
      src={staticFile('/images/book-trial-class/shape-4.svg')}
      className="absolute bottom-0 right-0 h-12 -mb-5 -mr-5 hidden lg:flex"
      alt="Background Vector Shape"
    />
    <LazyImage
      path={imageUrl}
      name={name}
      className="absolute top-0 right-1/2 lg:top-1/2 lg:right-0 w-48 -mr-24 -mt-24"
      alt={role}
    />
    <p className="text-grey text-center lg:text-left lg:mr-10 mt-20 lg:mt-0">
      {content}
    </p>
    <p className="font-600 text-sm mt-5 text-center lg:text-left">- {role}</p>
  </div>
)

const IMAGE_PATH = '/images/school-partnership/previous-partnerships/'

const PreviousPartnerships = () => {
  return (
    <div
      className="flex flex-col justify-between items-center align-center relative"
      style={{
        borderRadius: '0% 0% 120% 120%/10% 10% 10% 10%',
        background: '#EFF8FF',
      }}
    >
      <LazyImage
        path={IMAGE_PATH}
        name="left-shapes"
        className="hidden lg:flex absolute top-10 left-0 z-10"
        alt="Background left shapes"
      />
      <LazyImage
        path={IMAGE_PATH}
        name="right-shapes"
        className="hidden lg:flex absolute top-5 right-5 z-10 "
        alt="Background right shapes"
      />
      <h1 className="text-center font-700 text-4xl leading-tight text-grey lg:mx-auto mt-16 px-5">
        Previous Partnerships
      </h1>

      <div className="flex flex-col lg:flex-row items-center lg:mb-10 max-w-6xl mx-auto">
        <TestimonialCard
          content="'Our association with Codingal on the various cyber genius competitions has been really good. We look forward to working with them in the future.'"
          imageUrl={IMAGE_PATH}
          name="kavari-logo"
          role="- Dr. Kalmadi Shamrao High School"
        />

        <LazyImage
          path={IMAGE_PATH}
          name="guest-of-honour"
          alt="Satyam Baranwal guest of honour at Cyber Genius 2020"
          className="py-10 lg:py-1 px-5 mb-5 lg:mt-24 lg:h-64 lg:mx-5 md:max-w-md lg:max-w-xl"
        />
      </div>
    </div>
  )
}

export default PreviousPartnerships
